(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["filter-list-selection"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.filter-brands-block').forEach(details => {
        const searchInput = details.querySelector('.brand-search-input');
        const brandItems = details.querySelectorAll('.filter-item');
        
        // Vyhledávání uvnitř bloku (funguje beze změny)
        if (searchInput) {
            searchInput.addEventListener('input', (e) => {
                const query = searchInput.value.toLowerCase();
                brandItems.forEach(item => {
                    const label = item.querySelector('.filter-label').textContent.toLowerCase();
                    item.style.display = label.includes(query) ? 'flex' : 'none';
                });
            });
        }

        // Chytré odesílání filtru se zachováním parametrů v URL
        brandItems.forEach(item => {
            const checkbox = item.querySelector('.filter-checkbox');
            if (!checkbox) return;

            checkbox.addEventListener('change', () => {
                // 1. Získáme aktuální URL se všemi parametry (např. search, sortování atd.)
                const url = new URL(window.location.href);
                const paramName = checkbox.name;
                const paramValue = checkbox.value;

                // 2. Smažeme parametr 'page' (při změně filtru by měl zákazník začít zase od 1. stránky)
                url.searchParams.delete('page');

                // 3. Upravíme parametry podle toho, zda je zaškrtnuto nebo odškrtnuto
                if (checkbox.checked) {
                    url.searchParams.append(paramName, paramValue);
                } else {
                    // Smažeme konkrétní hodnotu (užitečné, pokud má jeden filtr více vybraných značek)
                    const allValues = url.searchParams.getAll(paramName);
                    url.searchParams.delete(paramName);
                    allValues.forEach(val => {
                        if (val !== paramValue) {
                            url.searchParams.append(paramName, val);
                        }
                    });
                }

                // 4. Místo form.submit() přesměrujeme prohlížeč na novou složenou URL
                window.location.href = url.toString();
            });
        });
    });
  } catch(e) { console.error(e); }
})();

})();
